import UserDelete from './UserDelete'
export default UserDelete
